
function formatThousands(value) {
  if (value === null || value === undefined || value === "") return "";
  const number = Number(String(value).replace(",", "."));
  return Number.isFinite(number)
    ? new Intl.NumberFormat("es-AR", { maximumFractionDigits: 2 }).format(number)
    : "";
}

function FormInput({ label, type="text", placeholder, value, onChange, thousandSeparator = false }) {
  const handleChange = (event) => {
    if (!thousandSeparator) {
      onChange(event);
      return;
    }

    const rawValue = event.target.value
      .replace(/\./g, "")
      .replace(",", ".")
      .replace(/[^\d.]/g, "")
      .replace(/(\..*?)\./g, "$1");
    onChange({ target: { name: event.target.name, value: rawValue } });
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <label className="cc-form-label">{label}</label>
      <input
        className="cc-form-input"
        type={thousandSeparator ? "text" : type}
        inputMode={thousandSeparator ? "numeric" : undefined}
        placeholder={placeholder}
        value={thousandSeparator ? formatThousands(value) : value}
        onChange={handleChange}
      />
    </div>
  );
}
export default FormInput;
